import type { PermissionsItemProps } from '@pages/AccessProfile/context/types'

export const getPermissionValue = (index: number, permissionItem: PermissionsItemProps) => {
  const permissions = {
    [0]: permissionItem.totalPermission,
    [1]: permissionItem.canApprove,
    [2]: permissionItem.canEdit,
    [3]: permissionItem.canCreate,
    [4]: permissionItem.canView,
    [5]: permissionItem.canDelete
  } as const

  return permissions[index as keyof typeof permissions]
}
